export enum ResidentServiceError {
  DUPLICATE_RESIDENT_ACCOUNTING_ID = 'DUPLICATE_RESIDENT_ACCOUNTING_ID',
  RESIDENT_ACCOUNTING_ID_ALREADY_SET = 'RESIDENT_ACCOUNTING_ID_ALREADY_SET',
  FAMILY_MEMBER_EMAIL_ALREADY_EXISTS = 'FAMILY_MEMBER_EMAIL_ALREADY_EXISTS',
  CONFLICTING_FAMILY_MEMBER_EMAIL = 'CONFLICTING_FAMILY_MEMBER_EMAIL',
}

export enum SettlementServiceError {
  START_DATE_AFTER_EXIT_DATE = 'START_DATE_AFTER_EXIT_DATE',
}
